export const VIEWS_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { intersect: false },
  plugins: {
    legend: { display: false },
    title: {
      display: true,
      text: 'Views Over Time',
      color: 'white',
    },
    datalabels: { display: false },
    filler: { propagate: true },
  },
  elements: {
    line: { tension: 1, fill: true },
    point: { radius: 2, hoverRadius: 6 },
  },
  scales: {
    x: {
      type: 'time',
      time: { unit: 'day', displayFormats: { day: 'YYYY-MM-DD' } },
      ticks: { maxTicksLimit: 8, maxRotation: 45, minRotation: 0, color: 'white' },
      grid: { color: 'rgba(31, 41, 55, 1)' },
    },
    y: {
      beginAtZero: true,
      ticks: { stepSize: 1, color: 'white' },
      grid: { color: 'rgba(31, 41, 55, 1)' },
    },
  },
};
